import {EventEmitter, Injectable, Output} from '@angular/core';
import {ProductEnum} from "../enum/product.enum";

@Injectable({
  providedIn: 'root',
})
export class ProductService {

  @Output() productSelected = new EventEmitter<ProductEnum>();

  public selectedProduct: ProductEnum;

  readonly OVERVIEW_URL = '/testcenter/overview';

  constructor() {

    this.checkProduct();
  }

  public checkProduct(): void {

    if(window.location.href.includes(ProductEnum.TESTAS.toLowerCase())) {

      this.selectProduct(ProductEnum.TESTAS);

    } else if(window.location.href.includes(ProductEnum.DMAT.toLowerCase())) {

      this.selectProduct(ProductEnum.DMAT);

    } else if(window.location.href.includes(ProductEnum.DTZ.toLowerCase())) {

      this.selectProduct(ProductEnum.DTZ);

    } else {

      this.selectProduct(ProductEnum.TESTDAF);
    }
  }

  private selectProduct(product: ProductEnum): void {

    this.selectedProduct = product;
    this.productSelected.emit(this.selectedProduct);
  }
}
